// extracted by mini-css-extract-plugin
module.exports = {"popover-content-container":"_34IB7","popoverContentContainer":"_34IB7","language":"h5qJc"};